import { IconSvg, IconSvgProps } from "./icon"

export default function Task(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M19.156 15.72L15.711 19.164A2.071 2.071 0 0 1 14.248 19.77H6.308A2.07 2.07 0 0 1 4.238 17.7V6.314A2.07 2.07 0 0 1 6.308 4.244H17.693A2.07 2.07 0 0 1 19.763 6.314V14.254A2.07 2.07 0 0 1 19.156 15.72Z" />
      <path d="M14.587 19.742V16.665A2.07 2.07 0 0 1 16.657 14.595H19.734" />
      <path d="M14.976 9.019L11.118 12.878A0.566 0.566 0 0 1 10.318 12.878L9.025 11.586" />
    </IconSvg>
  )
}
